import { Box, styled } from "@mui/material";

import { BasicButton } from "components/buttons/basic-button";

export const AssistantChoices = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
}));

export const AssistantChoiceButton = styled(BasicButton)(({ theme }) => ({
  ...theme.typography.subtitle8,
  height: "auto",
  minHeight: theme.spacing(8),
  padding: theme.spacing(3, 4),
  textAlign: "left",
  justifyContent: "flex-start",
}));
